import { n as e, t } from "../../../createEndpoints-BYEC3FIA.js";
import { t as n } from "../../../createQueryParams-D2aMgLX5.js";
import { t as r } from "../../../createCustomerPortalApiClient-D9X6mqNb.js";
//#region src/clients/customerPortal/v20240509/endpoints/quotes/quotes.cacheKeys.ts
var i = "quotes", a = "quotePdf", o = e({
	route: ({ customerId: e, quoteId: t }) => `/customer-portal/customers/${e}/quotes/${t}`,
	queryKey: [i],
	mocking: {
		match: /\/api\/customer-portal\/customers\/(.+)\/quotes\/(.+)/,
		mock: {
			id: "018fbed7-b1aa-7baa-ade6-0f3faaa4982d",
			createdBy: "test-user",
			createdByEmail: "sales@example.com",
			customerId: "test-customer",
			quoteNumber: "Q0001",
			title: "Test Quote",
			currency: "GBP",
			presentation: [],
			status: "PUBLISHED",
			dealType: "NEW_BUSINESS",
			publishedAt: (/* @__PURE__ */ new Date()).toISOString(),
			pdfStatus: "GENERATED",
			merchantBranding: {
				legalCompanyName: "Merchant name",
				address: {
					line1: "Line 1",
					town: "Town",
					postcode: "Postcode",
					country: "GB"
				},
				email: "merchant@example.com"
			},
			phases: [{
				id: "018fbed7-b1aa-7baa-ade6-0f3faaa4982d",
				duration: {
					months: 0,
					years: 1
				},
				prices: [
					{
						id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
						productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
						name: "More dolla",
						structure: {
							pricingType: "ONE_TIME",
							price: "3500.00"
						},
						billingFrequency: "ONE_TIME",
						billingType: "IN_ARREARS",
						customMetricParameters: []
					},
					{
						id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
						productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
						name: "More dolla",
						structure: {
							pricingType: "FIXED",
							price: "3500.00"
						},
						billingFrequency: "MONTHLY",
						billingType: "IN_ARREARS",
						customMetricParameters: []
					},
					{
						id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
						productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
						name: "More dolla",
						structure: {
							pricingType: "LINEAR",
							pricePerUnit: "3500.00",
							usageMetricId: "01956fe4-558a-465d-8e30-b948a8c4b132",
							isPricePercentage: !1
						},
						billingFrequency: "MONTHLY",
						billingType: "IN_ARREARS",
						customMetricParameters: []
					},
					{
						id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
						productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
						name: "More dolla",
						structure: {
							tiers: [{
								fee: "50.00",
								price: "25.00111",
								upperBound: "10000.01078",
								isPricePercentage: !1
							}, {
								fee: "0.00",
								price: "5.00",
								isPricePercentage: !1
							}],
							pricingType: "GRADUATED",
							usageMetricId: "018c59d2-dc31-7e4e-9202-ee1c239b31ce",
							usageCalculationMode: "BILLING_PERIOD"
						},
						billingFrequency: "MONTHLY",
						billingType: "IN_ARREARS",
						customMetricParameters: []
					},
					{
						id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
						productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
						name: "More dolla",
						structure: {
							tiers: [{
								fee: "50.00",
								price: "25.00111",
								upperBound: "10000.01078",
								isPricePercentage: !1
							}, {
								fee: "0.00",
								price: "5.00",
								isPricePercentage: !1
							}],
							pricingType: "VOLUME",
							usageMetricId: "018c59d2-dc31-7e4e-9202-ee1c239b31ce"
						},
						billingFrequency: "MONTHLY",
						billingType: "IN_ADVANCE",
						customMetricParameters: []
					},
					{
						id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
						productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
						name: "More dolla",
						structure: {
							tiers: [{
								fee: "50.00",
								price: "25.00111",
								upperBound: "10000.01078",
								isPricePercentage: !0,
								maxPrice: "10",
								minPrice: "1"
							}, {
								fee: "0.00",
								price: "5.00",
								isPricePercentage: !0,
								maxPrice: "10",
								minPrice: "1"
							}],
							pricingType: "VOLUME",
							usageMetricId: "018c59d2-dc31-7e4e-9202-ee1c239b31ce"
						},
						billingFrequency: "MONTHLY",
						billingType: "IN_ARREARS",
						customMetricParameters: []
					},
					{
						id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
						productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
						name: "More dolla",
						structure: {
							pricePerPackage: "10",
							packageSize: "20",
							pricingType: "PACKAGE",
							usageMetricId: "018c59d2-dc31-7e4e-9202-ee1c239b31ce"
						},
						billingFrequency: "YEARLY",
						billingType: "IN_ARREARS",
						customMetricParameters: [{
							parameterId: "079f93a2-e4d8-4729-a32a-de2511a7d1d1",
							value: "10"
						}]
					},
					{
						id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
						productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
						name: "More dolla",
						structure: {
							pricingType: "SEAT_BASED",
							seatMetricId: "2f97a232-d389-480b-b7ce-0610e6116ceb",
							pricePerSeat: "3500.00",
							prorationStrategy: "USE_MAXIMUM",
							contractedMinimumSeats: 10,
							tiers: [],
							prorateFlatFees: !1
						},
						billingFrequency: "MONTHLY",
						billingType: "IN_ARREARS",
						customMetricParameters: []
					},
					{
						id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
						productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
						name: "More dolla",
						structure: {
							pricingType: "SEAT_BASED",
							seatMetricId: "2f97a232-d389-480b-b7ce-0610e6116ceb",
							pricePerSeat: "3500.00",
							prorationStrategy: "USE_MAXIMUM",
							contractedMinimumSeats: 10,
							overagesBillingFrequency: "MONTHLY",
							tiers: [],
							prorateFlatFees: !1
						},
						billingFrequency: "YEARLY",
						billingType: "IN_ARREARS",
						customMetricParameters: []
					},
					{
						id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
						productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
						name: "More dolla",
						structure: {
							pricingType: "SEAT_BASED",
							seatMetricId: "2f97a232-d389-480b-b7ce-0610e6116ceb",
							pricePerSeat: "0",
							prorationStrategy: "USE_MAXIMUM",
							contractedMinimumSeats: 10,
							tiers: [{
								price: "25.00111",
								upperBound: "10000.01078"
							}, {
								price: "5.00",
								fee: "10.00"
							}],
							prorateFlatFees: !1
						},
						billingFrequency: "MONTHLY",
						billingType: "IN_ARREARS",
						customMetricParameters: []
					}
				],
				discounts: [],
				minimums: [{
					id: "018fbed7-b1aa-7baa-ade7-54f102f362cc",
					amount: "15",
					restrictToPrices: [],
					createdAt: "2024-05-28T10:55:57.866181Z",
					updatedAt: "2024-05-28T10:55:57.866181Z"
				}]
			}, {
				id: "018fbed7-b1cf-719c-b46d-04554289888e",
				duration: {
					months: 0,
					years: 1
				},
				prices: [{
					id: "018fbed7-b1cb-782b-b331-eeb71fe1cea3",
					productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
					name: "More dolla",
					structure: {
						pricingType: "FIXED",
						price: "3500.00"
					},
					billingFrequency: "MONTHLY",
					billingType: "IN_ARREARS",
					customMetricParameters: []
				}],
				discounts: [{
					id: "018fbed7-b1cf-719c-b46e-7deb87e939e6",
					restrictToPrices: ["018fbed7-b1cb-782b-b331-eeb71fe1cea3"],
					amount: "5",
					discountCalculationType: "PERCENTAGE",
					message: "New discount",
					createdAt: "2024-05-28T10:55:57.866181Z",
					updatedAt: "2024-05-28T10:55:57.866181Z"
				}],
				minimums: []
			}],
			customerName: "Test Customer",
			customerAddress: {
				line1: "Line 1",
				town: "Town",
				postcode: "Postcode",
				country: "GB"
			},
			contacts: [{
				name: "Firstname Lastname",
				email: "example@example.com"
			}, {
				name: "Firstname Lastname",
				email: "example@example.com",
				signedAt: "2024-05-28T10:55:57.866181Z"
			}],
			counterSigners: [{
				name: "Firstname Lastname",
				email: "example@example.com",
				signedAt: "2024-05-28T10:55:57.866181Z"
			}],
			isSignaturesEnabled: !0,
			isExpired: !1
		}
	}
}), s = e({
	route: ({ customerId: e, quoteId: t }) => `/customer-portal/customers/${e}/quotes/${t}/download`,
	queryKey: [a],
	config: { responseTransform: (e) => e.blob() },
	mocking: {
		match: /\/api\/customer-portal\/customers\/(.+)\/quotes\/(.+)\/download/,
		mock: new Blob([""], { type: "application/pdf" })
	}
}), c = t({
	route: ({ customerId: e, quoteId: t }) => `/customer-portal/customers/${e}/quotes/${t}/ready-to-sign`,
	method: "POST",
	invalidateQueries: [i],
	mocking: {
		match: /\/api\/customer-portal\/customers\/(.+)\/quotes\/(.+)\/ready-to-sign/,
		mock: void 0
	}
}), l = "invoices", u = r({
	endpoints: {
		getCustomerPortalInvoiceById: e({
			route: (e) => `/customer-portal/invoices/${e.invoiceId}`,
			queryKey: [l],
			mocking: {
				match: /\/api\/customer-portal\/invoices\/(.+)/,
				mock: {
					id: "ba37a392-7054-4dae-ab37-6fee9e23fe06",
					currency: "GBP",
					invoiceNumber: "INV2",
					issueDate: "2022-10-05",
					dueDate: "2022-11-05",
					paymentTermDays: 30,
					billingPeriod: {
						start: "2022-10-01",
						endInclusive: "2022-10-30"
					},
					grossTotal: "10",
					currentlyApplied: {
						creditNotes: [],
						payments: []
					},
					appliedCreditGrants: [],
					appliedCreditGrantTax: "0.00",
					paymentStatus: "UNPAID",
					purchaseOrderNumber: "PO123",
					customerLegalCompanyName: "Customer",
					customerBillingAddress: {
						line1: "Flat 1",
						line2: "123 Fake Street",
						town: "New York",
						state: "NY",
						postcode: "AB1 2EF",
						country: "US"
					},
					memo: "Memo",
					paymentOptions: ["BANK_TRANSFER"],
					customerTaxId: "GB123",
					totalTax: "2",
					netTotal: "8",
					merchantDetails: {
						address: {
							line1: "The White House",
							line2: "1600 Pennsylvania Avenue",
							town: "Washington, D.C.",
							state: "CA",
							postcode: "20500",
							country: "US"
						},
						phoneNumber: "0800001066",
						email: "donald@example.com",
						taxId: "TAX60",
						usAchDestination: {
							accountNumber: "12345678",
							accountName: "John Doe",
							bankName: "Chase",
							bankRoutingNumber: "123456789"
						},
						usWireDestination: {
							accountNumber: "12345678",
							accountName: "John Doe",
							bankName: "Chase",
							bankRoutingNumber: "123456789",
							swiftCode: "CHASUS33",
							bankAddress: {
								line1: "JP Morgan Chase",
								town: "New York City",
								state: "NY",
								postcode: "10017",
								country: "US"
							}
						},
						caBankAccountDestination: {
							transitNumber: "123",
							institutionNumber: "12345",
							accountNumber: "1234567"
						},
						canadianInternationalDestination: {
							legalName: "John Doe",
							accountNumber: "12345678",
							transitNumber: "123",
							bankName: "Chase",
							bankAddress: {
								line1: "JP Morgan Chase",
								town: "New York City",
								state: "NY",
								postcode: "10017",
								country: "US"
							},
							institutionNumber: "123",
							swiftCode: "CHASUS33",
							intermediaryBank: {
								bankName: "Chase",
								bankAddress: {
									line1: "JP Morgan Chase",
									town: "New York City",
									state: "NY",
									postcode: "10017",
									country: "US"
								},
								swiftCode: "CHASUS33",
								routingNumber: "123456789"
							}
						},
						australianDestination: {
							legalName: "John Doe",
							accountNumber: "12345678",
							swiftCode: "CHASUS33",
							bsb: "123456"
						},
						logoUrl: "logo",
						legalCompanyName: "The Merchant",
						primaryColour: "#000000",
						customFields: [{
							key: "example-label",
							value: "label-value"
						}],
						includeBeneficiaryAddressInPaymentDetails: !0
					},
					metadata: [{
						key: "key",
						value: "value"
					}],
					creditBalances: "balance",
					accountingDate: "2023-11-02",
					renderSettings: { paymentLinkDisplay: "SHOW_PAYMENT_LINK" }
				}
			}
		}),
		getCustomerPortalInvoices: e({
			route: ({ customerId: e, ...t }) => `/customer-portal/customers/${e}/invoices${n(t)}`,
			queryKey: [l],
			mocking: {
				match: /\/api\/customer-portal\/customers\/(.+)\/invoices(\?(.*))?$/,
				mock: {
					items: [{
						id: "ba37a392-7054-4dae-ab37-6fee9e23fe06",
						currency: "GBP",
						invoiceNumber: "INV2",
						issueDate: "2022-10-05",
						dueDate: "2022-11-05",
						paymentTermDays: 30,
						billingPeriod: {
							start: "2022-10-01",
							endInclusive: "2022-10-30"
						},
						grossTotal: "10",
						paymentStatus: "UNPAID",
						purchaseOrderNumber: "PO123",
						customerLegalCompanyName: "Customer",
						customerBillingAddress: {
							line1: "Flat 1",
							line2: "123 Fake Street",
							town: "New York",
							state: "NY",
							postcode: "AB1 2EF",
							country: "US"
						},
						memo: "Memo",
						paymentOptions: ["BANK_TRANSFER"],
						customerTaxId: "GB123",
						totalTax: "2",
						netTotal: "8",
						merchantDetails: {
							address: {
								line1: "The White House",
								line2: "1600 Pennsylvania Avenue",
								town: "Washington, D.C.",
								state: "CA",
								postcode: "20500",
								country: "US"
							},
							phoneNumber: "0800001066",
							email: "donald@example.com",
							taxId: "TAX60",
							usAchDestination: {
								accountNumber: "12345678",
								accountName: "John Doe",
								bankName: "Chase",
								bankRoutingNumber: "123456789"
							},
							usWireDestination: {
								accountNumber: "12345678",
								accountName: "John Doe",
								bankName: "Chase",
								bankRoutingNumber: "123456789",
								swiftCode: "CHASUS33",
								bankAddress: {
									line1: "JP Morgan Chase",
									town: "New York City",
									state: "NY",
									postcode: "10017",
									country: "US"
								}
							},
							caBankAccountDestination: {
								transitNumber: "123",
								institutionNumber: "12345",
								accountNumber: "1234567"
							},
							canadianInternationalDestination: {
								legalName: "John Doe",
								accountNumber: "12345678",
								transitNumber: "123",
								bankName: "Chase",
								bankAddress: {
									line1: "JP Morgan Chase",
									town: "New York City",
									state: "NY",
									postcode: "10017",
									country: "US"
								},
								institutionNumber: "123",
								swiftCode: "CHASUS33",
								intermediaryBank: {
									bankName: "Chase",
									bankAddress: {
										line1: "JP Morgan Chase",
										town: "New York City",
										state: "NY",
										postcode: "10017",
										country: "US"
									},
									swiftCode: "CHASUS33",
									routingNumber: "123456789"
								}
							},
							australianDestination: {
								legalName: "John Doe",
								accountNumber: "12345678",
								swiftCode: "CHASUS33",
								bsb: "123456"
							},
							logoUrl: "logo",
							legalCompanyName: "The Merchant",
							primaryColour: "#000000",
							customFields: [{
								key: "example-label",
								value: "label-value"
							}],
							includeBeneficiaryAddressInPaymentDetails: !0
						},
						metadata: [{
							key: "key",
							value: "value"
						}],
						creditBalances: "balance",
						accountingDate: "2023-11-02",
						renderSettings: { paymentLinkDisplay: "SHOW_PAYMENT_LINK" }
					}],
					pagination: {
						after: "",
						before: "",
						totalResultSize: 1
					}
				}
			}
		}),
		getCustomerPortalQuote: o,
		downloadQuotePdf: s,
		postReadyToSign: c
	},
	version: "2024-05-09"
});
//#endregion
export { u as customerPortalv20240509Client };

//# sourceMappingURL=index.js.map